import { industriesData } from "../data/mock";
import {
  Building2, Store, Heart, Briefcase, UtensilsCrossed,
  Building, Home, Factory, Globe
} from "lucide-react";

const iconMap = {
  Building2, Store, Heart, Briefcase, UtensilsCrossed,
  Building, Home, Factory,
};

export const IndustriesSection = () => {
  return (
    <section id="industries" className="py-20 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-brand-50 rounded-full px-4 py-1.5 mb-5 border border-brand-100">
            <Globe className="w-4 h-4 text-brand-600" />
            <span className="text-sm font-medium text-brand-700">Industries We Serve</span>
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
            Trusted Partner Across Diverse Sectors
          </h2>
          <p className="text-slate-500 max-w-2xl mx-auto text-base">
            Delivering world-class HVAC infrastructure for shopping malls, corporate offices, healthcare facilities, hospitality chains &amp; manufacturing plants across India.
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 lg:gap-5">
          {industriesData.map((industry, index) => {
            const IconComp = iconMap[industry.icon] || Building2;
            return (
              <div
                key={index}
                className="group bg-white rounded-xl p-6 text-center border border-slate-100 hover:border-brand-200 hover:shadow-md transition-all duration-300 hover:-translate-y-1 cursor-default"
              >
                <div className="w-14 h-14 rounded-2xl bg-brand-50 group-hover:bg-brand-100 flex items-center justify-center mx-auto mb-4 transition-all duration-300">
                  <IconComp className="w-6 h-6 text-brand-600" />
                </div>
                <h3 className="text-sm font-semibold text-slate-700 group-hover:text-brand-700 transition-colors">
                  {industry.name}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
